<template>
  <div id="personality-matrix-modal-parent">
    <Page title="性格マトリクス">
      <template v-slot:action>
        <ActionButton title="性格分析とは" color="primary" shape="round" width="150" @click="showTutorial" />
      </template>
      <template v-slot:content>
        <div class="uk-card uk-card-default uk-card-body" :class="{ 'main-hidden': activePath === 'sub' }">
          <div class="content-header">
            <ActionButton
              title="分析対象追加"
              color="primary"
              width="150"
              @click="onAddButtonClick"
              :uk-tooltip="`title: 分析可能人数は${participantsMin}人〜${participantsMax}人です。; pos: top-left;`"
            />
            <ActionButton title="印刷" color="primary" shape="round" width="150" @click="onPrintButtonClick" />
          </div>
          <div class="content-main">
            <div class="selected-users">
              <UserSelector :users="selectedUsers" :readOnly="true" :selectable="true" @user-click="onUserSelect" />
            </div>
            <PersonalityMatrixChart :chartData="stats" />
          </div>
        </div>
        <div class="uk-flex-top" uk-modal ref="selectionModal" container="#personality-matrix-modal-parent" :bg-close="false">
          <div class="uk-modal-dialog uk-margin-auto-vertical">
            <div class="uk-modal-body">
              <DepartmentUserSelector
                :key="departmentUserSelectorFormKey"
                :full="true"
                :analysisFlg="true"
                :includeRetired="true"
                :initialSelectedUsers="selectedUsers"
                :participantsMax="participantsMax"
                :participantsMin="participantsMin"
                @user-selection-change="onTargetUserSelectionChange"
                @on-selection-done-button-click="onSelectionDoneButtonClick"
                @close="onCloseButtonClick"
                v-on:keydown.esc="onCloseButtonClick"
              />
            </div>
          </div>
        </div>
      </template>
    </Page>
  </div>
</template>
<style lang="scss" scoped>
.chart-action-button {
  width: 100%;
  display: flex;
  justify-content: flex-end;
}
.action .action-button:first-child {
  margin-right: $spacing-medium;
}
.uk-card-body {
  .content-main {
    display: flex;
  }
  .content-header {
    display: flex;
    justify-content: space-between;
    margin-bottom: $spacing-ex-small;
  }
}
.selected-users {
  width: 250px;
  min-width: 250px;
  margin-right: $spacing-medium;
  max-height: 500px;
  min-height: 300px;
  .user-selector-container {
    height: 100%;
  }
}
.main-hidden {
  display: none;
}
.uk-modal-dialog {
  width: unset;
  min-width: 960px;
}
.uk-modal-header {
  border-bottom: 0;
}
</style>
<script lang="ts">
import { Options } from "vue-class-component";
import Page from "../molecules/Page.vue";
import ActionButton from "../atoms/ActionButton.vue";
import UserSelector from "../molecules/UserSelector.vue";
import DepartmentUserSelector from "../organisms/DepartmentUserSelector.vue";
import PersonalityMatrixChart from "../atoms/PersonalityMatrixChart.vue";
import { SelectableProfile, GetPersonalityMatrix, GetProfile } from "../../types";
import { StatsItemEnum } from "../../autogen";
import { print } from "../../helpers/view-utils";
import ChartViewMixin from "../../helpers/mixins/chart-view";

@Options({
  components: {
    Page,
    ActionButton,
    UserSelector,
    DepartmentUserSelector,
    PersonalityMatrixChart
  }
})
export default class PersonalityMatrix extends ChartViewMixin {
  selectedUsers: SelectableProfile[] = [];
  stats: (GetPersonalityMatrix & GetProfile)[] = [];
  activePath = "main";
  participantsMin = 1;
  participantsMax = 100;
  targetStats = StatsItemEnum.PersonalityMatrix;
  departmentUserSelectorFormKey = 0;
  tutorialImagePath = require("@/assets/image/PMatrixTutorial.png");
  async onSelectionDone() {
    this.stats = this.selectedUsers.map(selectedUser =>
      Object.assign(this.chartData![selectedUser.id].profile, this.chartData![selectedUser.id].stats["PersonalityMatrix"], {
        id: selectedUser.id
      })
    );
  }
  onPrintButtonClick() {
    print(StatsItemEnum.PersonalityMatrix, this.stats);
  }
}
</script>
